import { Injectable } from '@angular/core';
import { jsPDF } from 'node_modules/jspdf/dist/jspdf.es.js';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor() {}

  downloadVaultKeyAsPdf(filename, text) {
    const doc = new jsPDF();
    doc.text(text, 10, 10);
    doc.save(filename);
  }

  downloadVaultKeyAsText(filename, text) {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}
